import React from 'react';
import ReactDOM from 'react-dom';
import { PanelContext } from './PanelState';
import { isMobileScreen } from 'utility';

export class RightPortal extends React.Component {
	constructor(props) {
		super(props);
		// Create a div that we'll render the modal into. Because each
		// Modal component has its own element, we can render multiple
		// modal components into the modal container.
		//@ts-ignore
		this.el = document.createElement('div');
	}

	componentDidMount() {
		// Append the element into the DOM on mount. We'll render
		// into the modal container element (see the HTML tab).
		const rightPortal = document.getElementById('right-portal');
		//@ts-ignore
		rightPortal.appendChild(this.el);
		this.context.setRightPanelUsed(true);
		if (!isMobileScreen()) {
			this.context.openRightPanel();
		}
	}

	componentWillUnmount() {
		// Remove the element from the DOM when we unmount
		const rightPortal = document.getElementById('right-portal');
		//@ts-ignore
		rightPortal.removeChild(this.el);
		this.context.closeRightPanel();
		this.context.setRightPanelUsed(false);
	}

	render() {
		// Use a portal to render the children into the element
		return ReactDOM.createPortal(
			// Any valid React child: JSX, strings, arrays, etc.
			this.props.children,
			// A DOM element
			//@ts-ignore
			this.el
		);
	}
}
RightPortal.contextType = PanelContext;